/**
 * Related Items Row Component
 * Vertical grid of related item cards
 */

import React from 'react';
import RelatedItemCard from './RelatedItemCard';
import RelatedItemSkeleton from './RelatedItemSkeleton';

/**
 * Related Items Row
 * @param {Object} props
 * @param {Array} props.items - Array of related items
 * @param {boolean} props.loading - Loading state
 * @param {Function} props.onItemClick - Click handler for items
 */
export default function RelatedItemsRow({ items = [], loading = false, onItemClick }) {
  return (
    <div className="w-full">
      {loading ? (
        <RelatedItemSkeleton count={6} />
      ) : items.length > 0 ? (
        <div className="grid grid-cols-3 gap-3">
          {items.map((item) => (
            <RelatedItemCard
              key={item.id}
              item={item}
              onClick={() => onItemClick && onItemClick(item)}
            />
          ))}
        </div>
      ) : null}
    </div>
  );
}

